export const PrivateChatGeneric = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <g clipPath="url(#clip0_3902_17926)">
      <path
        d="M12.6666 5.33333V4.66667C12.6666 3.42899 12.1749 2.242 11.2998 1.36684C10.4246 0.491665 9.2376 0 7.99992 0C6.76224 0 5.57526 0.491665 4.70009 1.36684C3.82492 2.242 3.33325 3.42899 3.33325 4.66667V5.33333H1.33325V14C1.33325 14.5304 1.54397 15.0391 1.91904 15.4142C2.29411 15.7893 2.80282 16 3.33325 16H12.6666C13.197 16 13.7057 15.7893 14.0808 15.4142C14.4559 15.0391 14.6666 14.5304 14.6666 14V5.33333H12.6666ZM8.66659 12H7.33325V9.33333H8.66659V12ZM11.3333 5.33333H4.66659V4.66667C4.66659 3.78261 5.01777 2.93477 5.6429 2.30964C6.26802 1.68452 7.11586 1.33333 7.99992 1.33333C8.88397 1.33333 9.73182 1.68452 10.3569 2.30964C10.9821 2.93477 11.3333 3.78261 11.3333 4.66667V5.33333Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_3902_17926">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
